export default function Hero() {
  return (
    <section
      id="top"
      className="relative min-h-[720px] md:min-h-[820px] w-full overflow-hidden flex items-center"
    >
      {/* Background image — dark, atmospheric data center / network abstract */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Atmospheric%20cinematic%20interior%20of%20a%20modern%20server%20room%20and%20data%20center%20aisle%20with%20softly%20glowing%20warm%20amber%20LED%20strips%20along%20the%20server%20rack%20columns%2C%20deep%20charcoal%20walls%20and%20polished%20black%20floor%20reflecting%20light%2C%20thin%20horizontal%20light%20streaks%20in%20the%20background%2C%20fine%20haze%20and%20subtle%20film%20grain%2C%20editorial%20architectural%20photography%2C%20high%20contrast%2C%20cinematic%20shallow%20depth%20of%20field%2C%20balanced%20composition%20centered%20on%20a%20long%20aisle%20perspective%20receding%20into%20soft%20darkness&width=2000&height=1200&seq=alon-hero-bg-01&orientation=landscape"
          alt="Data center backdrop"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/80"></div>
        <div className="absolute inset-0 dotted-bg opacity-40"></div>
      </div>

      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 md:px-8 py-24 md:py-32">
        <div className="max-w-3xl fade-up">
          <div className="inline-flex items-center gap-2 rounded-full bg-background-50/10 border border-background-50/20 px-3 py-1.5 mb-6 backdrop-blur">
            <span className="w-2 h-2 rounded-full bg-primary-400 animate-pulse"></span>
            <span className="text-xs md:text-sm font-medium text-background-50/90 tracking-wide">
              Available for advisory & new engagements
            </span>
          </div>

          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-[1.05] tracking-tight">
            Building the systems{" "}
            <span className="text-primary-400">the world runs on</span>{" "}
            for three decades.
          </h1>

          <p className="mt-6 md:mt-8 text-base md:text-xl text-background-100/85 leading-relaxed max-w-2xl">
            I'm <strong className="text-background-50 font-semibold">Alon Hahamy</strong> — a
            technology executive with 30+ years in{" "}
            <span className="text-primary-300">Computer Networks & Data Center Infrastructure</span>{" "}
            and 25+ years in{" "}
            <span className="text-primary-300">High-Tech Security & IoT</span>. I design,
            secure, and scale mission-critical systems for governments, airports,
            military, law enforcement, and Fortune 500 enterprises.
          </p>

          <div className="mt-8 md:mt-10 flex flex-col sm:flex-row gap-3 sm:gap-4">
            <a
              href="#ventures"
              className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 hover:bg-primary-600 px-6 py-3.5 text-sm md:text-base font-semibold text-background-50 dark:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer"
            >
              Explore my companies
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </a>
            <a
              href="#contact"
              className="inline-flex items-center justify-center gap-2 rounded-md bg-background-50/10 hover:bg-background-50/20 border border-background-50/30 px-6 py-3.5 text-sm md:text-base font-semibold text-background-50 backdrop-blur transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-send-line w-4 h-4 flex items-center justify-center"></i>
              Start a conversation
            </a>
          </div>

          {/* Hero stats */}
          <div className="mt-14 md:mt-20 grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-10 max-w-3xl">
            {[
              { n: "30+", l: "Years in Networks & Data Centers" },
              { n: "25+", l: "Years in Security & IoT" },
              { n: "9", l: "Companies founded & led" },
              { n: "50+", l: "Industries served" },
            ].map((s) => (
              <div key={s.l}>
                <div className="font-heading text-3xl md:text-5xl font-bold text-primary-400 leading-none">
                  {s.n}
                </div>
                <div className="mt-2 text-xs md:text-sm text-background-100/80 leading-snug">
                  {s.l}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <a
        href="#about"
        className="hidden md:flex absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex-col items-center gap-2 text-background-50/70 hover:text-background-50 cursor-pointer transition-colors"
      >
        <span className="text-xs uppercase tracking-widest">Scroll</span>
        <i className="ri-arrow-down-line text-xl animate-bounce"></i>
      </a>
    </section>
  );
}